<div
  class="flex flex-col"
  [style.height]="'calc(100svh - var(--env-banner-height, 0px))'"
>
  <header class="flex-none p-5">
    <img
      src="pkvverlag_logo.png"
      class="float-start"
    >
  </header>

  <div class="flex flex-1 flex-row h-full w-full">
    <div
      id="sidebar"
      class="flex-none flex flex-col"
    >
      @if (this.clockService.isExamMode()) {
      <div
        id="clock"
        class="flex-none bg-white text-center text-xs p-2 m-5 rounded-2xl"
      >{{this.clockService.clockStr}}</div>
      }
      <div
        id="progress-container"
        class="mx-5 flex-none flex items-center justify-center"
        [ngClass]="{'mt-3': !this.clockService.isExamMode()}"
      >
        <img
          id="progress"
          [src]="this.progressUrl"
          width="50%"
        >
      </div>
      <div
        id="task-col"
        class="flex-1 overflow-x-auto"
      >
        <div
          class="target-btn"
          [ngClass]="{'stage-active': this.api.fallaufgabeStatus!.userSelectedAufgabenId == null}"
          (click)="this.chatService.selectAufgabe(null); this.submitService.solutionsVisible = false;"
        >
          <span>Einführung</span>
        </div>
        @if (this.api.fallaufgabe) {
        @for (aufgabe of this.api.fallaufgabe.aufgaben; track $index) {
        <div
          class="target-btn"
          (click)="this.chatService.selectAufgabe(aufgabe._id); this.submitService.solutionsVisible = false;"
          [ngClass]="{'stage-active': this.api.fallaufgabeStatus!.userSelectedAufgabenId == aufgabe._id}"
        >
          <span>Aufgabe {{aufgabe.aufgabenIndex}}</span>
          <i
            class="ri ri-xl status text-end"
            [ngClass]="{
            'ri-checkbox-blank-circle-line': !this.aufgabeInProgress(aufgabe),
            'ri-progress-3-line': this.aufgabeInProgress(aufgabe) && !this.aufgabeCompleted(aufgabe),
            'ri-checkbox-circle-fill': this.aufgabeCompleted(aufgabe)
            }"
          ></i>
        </div>
        }
        }
      </div>
      <div class="flex-none flex flex-col gap-2 mb-2 p-2">
        @if(this.api.fallaufgabe?.hints != '' && this.api.fallaufgabe?.hints != '<p></p>') {
        <p-button
          fluid
          label="Bearbeitungshinweise"
          (onClick)="this.showHints= !this.showHints"
          severity="info"
          outlined="true"
          [raised]="!this.showHints"
        />
        }
        <p-button
          fluid
          severity="info"
          outlined="true"
          label="Gespeicherte Antworten"
          (onClick)="this.showSolutionsDialog(false)"
          [raised]="true"
        />
        <hr>
        <p-button
          fluid
          severity="success"
          label="Kontrollieren und abgeben"
          (onClick)="this.showSolutionsDialog(true)"
          [raised]="true"
        />
      </div>
    </div>
    <div class="flex-1 overflow-x-scroll">
      @if (this.submitService.solutionsVisible) {
      <app-solutions></app-solutions>
      } @else if (this.chatUnlocked) {
      <app-chat></app-chat>
      } @else {
      <div class="flex h-full items-center justify-center p-6 text-center text-sm">
        Bitte bestätigen Sie den Disclaimer, um den Chat zu nutzen.
      </div>
      }
    </div>
  </div>
</div>

<p-dialog
  header="Rechtlicher Hinweis"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="this.showDisclaimerModal"
  [style]="{ width: 'min(90vw, 32rem)' }"
>
  <div class="flex flex-col gap-2">
    <div class="disclaimer-text flex flex-col gap-1 text-sm">
      <p>
        Dieser Bot wurde von der PKV Institut GmbH bereitgestellt und dient der Unterstützung bei Verständnis-Checks
        sowie Prüfungsfallaufgaben im Rahmen der Fernlehrgänge.
      </p>
      <p>
        Bitte geben Sie keine sensiblen oder vertraulichen personenbezogenen Daten in den Chat ein.
      </p>
      <p>
        Die eingegebenen Inhalte werden zur Verarbeitung an KI-Systeme übermittelt. Die technische Bereitstellung
        erfolgt durch die reflact AG als Dienstleister im Rahmen einer Auftragsverarbeitung. Die Inhalte werden nicht
        zum Training der KI-Modelle verwendet.
      </p>
      <p>
        Chatverläufe und Eingaben können zur Bereitstellung und technischen Absicherung des Dienstes gespeichert und
        verarbeitet werden. Weitere Informationen zur Datenverarbeitung finden Sie in unserer Datenschutzerklärung sowie
        unter: <a
          href="https://reflact.com/datenschutzerklaerung/"
          target="_blank"
        >Datenschutzerklärung - reflact AG</a>.
      </p>
    </div>
    <div class="flex items-center gap-2 mt-3">
      <p-checkbox
        inputId="hideDisclaimer"
        [binary]="true"
        [(ngModel)]="this.dontShowDisclaimerAgain"
      />
      <label for="hideDisclaimer">Nicht mehr anzeigen</label>
    </div>
    <p-button
      fluid
      label="Verstanden"
      (onClick)="this.confirmDisclaimer()"
      [raised]="true"
      class="mt-2"
    />
  </div>
</p-dialog>

<p-dialog
  header="Bearbeitungshinweise"
  [modal]="false"
  [(visible)]="this.showHints"
  [style]="{ width: '25rem' }"
  position="top"
>
  <div
    class="flex items-center gap-4 mb-4"
    [innerHTML]="this.api.fallaufgabe?.hints"
  ></div>

</p-dialog>

<p-dialog
  header="Verbindung zum Server unterbrochen"
  [modal]="true"
  [closable]="false"
  [(visible)]="this.disconnectionService.disconnectionDetected"
  [style]="{ width: '25rem' }"
>
  <div class="flex items-center gap-4 mb-4">
    {{this.disconnectionService.msg}}
  </div>
  <p-button
    fluid
    severity="success"
    label="Erneut verbinden"
    (onClick)="this.disconnectionService.retryConnection()"
    [raised]="true"
  />

</p-dialog>